{
  "title": "Track",
  "seg": { "label": "Track views", "day": "Day", "week": "Week" },
  "since": {
    "label": "Time since", "feed": "Last feed", "feeding": "Feeding", "diaper": "Last diaper", "awake": "Awake", "asleep": "Asleep", "lastSleep": "Last sleep",
    "justNow": "just now", "agoShort": "ago", "none": "No entry yet", "ago": "{{time}} ago", "for": "for {{time}}", "forUnderMin": "for less than a minute",
    "logFeed": "Log a feed", "logDiaper": "Log a diaper", "logSleep": "Log sleep"
  },
  "more": { "open": "More to log", "title": "What to log?" },
  "status": { "syncing": "Syncing…", "waiting": "Not synced yet", "offline": "Offline" },
  "log": { "title": "Log", "running": "running now" },
  "tile": {
    "sleep": "Sleep", "breast": "Breast", "bottle": "Bottle", "diaper": "Diaper", "pump": "Pump", "solids": "Solids",
    "medicine": "Medicine", "temperature": "Temp", "growth": "Growth", "note": "Note", "own": "Add your own"
  },
  "kind": {
    "sleep": "Sleep", "breast": "Breastfeed", "bottle": "Bottle", "pump": "Pump", "solids": "Solids", "diaper": "Diaper",
    "medicine": "Medicine", "growth": "Growth", "temperature": "Temperature", "custom": "Entry", "note": "Note"
  },
  "new": {
    "sleep": "Sleep", "breast": "Breastfeeding", "bottle": "Bottle", "pump": "Pumping", "solids": "Solids", "diaper": "Diaper",
    "medicine": "Medicine", "growth": "Growth", "temperature": "Temperature", "custom": "Entry", "note": "Note"
  },
  "sheet": { "close": "Close" },
  "edit": {
    "goneTitle": "Entry removed",
    "gone": "This entry was deleted, maybe on another phone.",
    "conflict": "This entry was just changed on another phone. You're seeing the latest version. Edit it again if needed.",
    "loggedBy": "Logged by {{who}} at {{time}}"
  },
  "who": { "you": "You", "someone": "Family member" },
  "form": {
    "time": "Time", "started": "Started", "ended": "Ended", "fellAsleep": "Fell asleep", "wokeUp": "Woke up",
    "emptyEnd": "Leave the end empty to start a timer.", "stillRunning": "No end yet: the timer keeps running.",
    "note": "Note", "notePlaceholder": "Optional", "save": "Save", "startTimer": "Start timer", "delete": "Delete entry"
  },
  "sleep": {
    "where": "Where (optional)",
    "loc": { "crib": "Crib", "own_bed": "Own bed", "parents_bed": "Our bed", "stroller": "Stroller", "car": "Car", "arms": "In arms", "other": "Other" }
  },
  "side": { "left": "Left", "right": "Right", "leftShort": "L", "rightShort": "R" },
  "breast": {
    "start": "Start", "next": "Next side", "suggested": "suggested",
    "startSide": "Start feeding on the {{side}} side",
    "lastHint": "Last feed ended on the {{side}} side at {{time}}.",
    "firstHint": "Tap a side to start the stopwatch.",
    "alreadyRunning": "A feed is running. Switch sides or stop it in the card at the top.",
    "past": "Or log a past feed", "startHint": "Leave the time as it is if the feed just ended.",
    "leftMin": "Left (min)", "rightMin": "Right (min)", "firstSide": "Started on",
    "runningEdit": "This feed is still running, now on the {{side}} side. You can change when it started."
  },
  "bottle": {
    "amount": "Amount ({{unit}})", "quick": "Common amounts", "what": "What was in it",
    "content": { "breastmilk": "Breast milk", "formula": "Formula", "mixed": "Mixed", "other": "Other" }
  },
  "pump": { "left": "Left ({{unit}})", "right": "Right ({{unit}})", "total": "Or total ({{unit}})", "totalHint": "Use the total if you didn't measure each side." },
  "solids": { "foods": "Foods", "foodsHint": "Separate with commas, e.g. banana, oatmeal", "reaction": "Reaction (optional)" },
  "diaper": { "legend": "Diaper", "wet": "Wet", "dirty": "Dirty", "mixed": "Both", "dry": "Dry" },
  "med": {
    "name": "Medicine", "recent": "Recent medicines", "dose": "Dose (optional)", "unit": "Unit",
    "units": { "ml": "ml", "mg": "mg", "drops": "drops", "tablet": "tablet" }
  },
  "growth": { "weight": "Weight", "lb": "Pounds", "oz": "Ounces", "length": "Length", "head": "Head", "headShort": "head" },
  "temp": {
    "value": "Temperature ({{unit}})", "how": "Measured (optional)",
    "method": { "none": "Not sure", "rectal": "Rectal", "axillary": "Under the arm", "oral": "Mouth", "ear": "Ear", "forehead": "Forehead", "other": "Other" }
  },
  "custom": { "value": "Value (optional)", "valueHint": "A number or a few words." },
  "note": { "label": "Note", "placeholder": "What happened?" },
  "category": {
    "title": "Your own category",
    "intro": "Track anything else, like tummy time or baths. Everyone in the family will see it.",
    "name": "Name", "placeholder": "e.g. Tummy time", "kind": "It is", "event": "A moment", "duration": "Takes time",
    "create": "Add category", "added": "{{name}} added to the log",
    "errors": {
      "category_exists": "There is already a category with this name.",
      "too_many_categories": "You've reached the limit of categories.",
      "role_not_allowed": "Only parents can add categories.",
      "offline": "You're offline. Add categories when you're back online."
    }
  },
  "errors": { "generic": "Something went wrong. Please try again." },
  "fever": {
    "title": "Call your pediatrician now",
    "body": "A temperature of {{temp}} or higher in a baby under 3 months needs a doctor's check right away, even if your baby seems fine. Call your pediatrician now, day or night.",
    "emergency": "If your baby is hard to wake, breathing fast or with effort, or looks very unwell, call 911.",
    "ok": "Saved. Close"
  },
  "err": {
    "time": "Enter a date and time.",
    "future": "That time is in the future.",
    "endBeforeStart": "The end is before the start.",
    "tooLong": "That's longer than {{hours}} hours. Check the times.",
    "range": "Enter a value between {{min}} and {{max}}.",
    "number": "Enter a number.",
    "required": "Please fill this in.",
    "pick": "Pick one.",
    "breastMinutes": "Enter the minutes for at least one side.",
    "growthOne": "Enter at least one measurement.",
    "alreadyRunning": "A timer is already running. Stop it first or enter an end time."
  },
  "running": {
    "label": "Running timers",
    "sleeping": "{{name}} is sleeping", "feeding": "Feeding · {{side}}", "paused": "Feed paused",
    "since": "Since {{time}}", "edit": "Edit {{name}}",
    "wokeUp": "Woke up", "stop": "Stop", "pause": "Pause", "resume": "Resume", "switchTo": "Switch to {{side}}",
    "stopped": "{{name}} saved · {{time}}", "switched": "Now on the {{side}} side", "pausedSaid": "Feed paused", "resumed": "Feed resumed"
  },
  "row": {
    "nap": "Nap", "nightSleep": "Night sleep", "running": "running", "since": "since {{time}}",
    "waking": "Woke at night", "awake": "{{time}} awake", "notSynced": "not synced yet", "edit": "Edit: {{what}}",
    "loggedBy": "Logged by {{who}}", "now": "now"
  },
  "day": { "today": "Today", "yesterday": "Yesterday", "prev": "Previous day", "next": "Next day" },
  "summary": {
    "sleep": "Sleep {{time}}",
    "feeds_one": "{{count}} feed", "feeds_other": "{{count}} feeds",
    "diapers_one": "{{count}} diaper", "diapers_other": "{{count}} diapers"
  },
  "timeline": {
    "loading": "Loading your log…",
    "emptyToday": "Nothing logged yet today. Tap + to log.",
    "hint": "Tap an entry to edit or delete it.",
    "empty": "Nothing was logged this day.",
    "night": "Night", "morning": "Morning", "afternoon": "Afternoon", "evening": "Evening"
  },
  "toast": { "deleted": "{{name}} deleted", "undo": "Undo" },
  "sync": {
    "waiting": "Saved on this phone · will sync",
    "offline": "Offline · new entries stay on this phone",
    "consent": "Please allow Baby Plan to store your baby's health data so entries can sync.",
    "consentLink": "Allow in Settings",
    "feature": "Syncing needs Baby Plan. Your entries stay on this phone.",
    "conflict": "A {{name}} entry was changed on another phone. We kept that version.",
    "conflictDeleted": "A {{name}} entry was deleted on another phone.",
    "notSaved": "{{name}} not saved.",
    "rejected": {
      "ongoing_exists": "Another one is already running.",
      "start_in_future": "The time was in the future.",
      "end_in_future": "The time was in the future.",
      "start_before_birth": "The time was before the birth date.",
      "duration_too_long": "It was too long.",
      "value_out_of_range": "A value was out of range.",
      "invalid_entry": "Something in it was not valid.",
      "category_not_found": "Its category no longer exists.",
      "role_not_allowed": "You can only delete your own entries.",
      "other": "Please try again."
    }
  },
  "forgot": {
    "title": "Forgot to stop the {{name}} timer?", "titleSleep": "Forgot to stop the sleep timer?",
    "body": "Started {{when}}, {{ago}} ago. When did it end?",
    "days_one": "{{count}} day", "days_other": "{{count}} days",
    "quick": "Ended at {{time}}", "pick": "Pick the end time", "pickWake": "Pick the wake-up time",
    "saved": "{{name}} saved, ended at {{time}}"
  },
  "check": {
    "title_one": "Check {{count}} entry", "title_other": "Check {{count}} entries",
    "lead": "These timers were left on, so we closed them with a usual length. Fix the end time if you remember it.",
    "span": "{{from}} – {{to}} · {{len}}", "guessed": "End time guessed",
    "fix": "Fix time", "ok": "Looks right",
    "more_one": "And {{count}} more", "more_other": "And {{count}} more",
    "sheetNote": "This timer was left on, so the end time is our guess. Set the real time and save."
  },
  "away": {
    "title": "Welcome back!", "body": "Nothing was logged since {{date}}. The days in between stay empty, and that's fine: the numbers only use days you logged.",
    "firstTitle": "Let's start the log", "firstBody": "Nothing logged yet. Every sleep, feed and diaper you add makes the plan fit your baby better.",
    "log": "Log what's happening now"
  },
  "strip": { "label": "Pick a day", "today": "Back to today", "prev": "Earlier days", "next": "Later days" },
  "list": { "title": "Entries" },
  "dsum": {
    "label": "The day in numbers", "soFar": "so far",
    "sleep": "Sleep", "feeds": "Feeds", "diapers": "Diapers", "wake": "Woke up",
    "night": "Night {{time}}", "naps_one": "{{count}} nap {{time}}", "naps_other": "{{count}} naps {{time}}",
    "noSleep": "No sleep logged", "noFeeds": "No feeds logged", "noDiapers": "No diapers logged",
    "bottle": "Bottle {{amount}}", "breast": "Breast {{time}}", "solids_one": "{{count}} solids", "solids_other": "{{count}} solids",
    "wet_one": "{{count}} wet", "wet_other": "{{count}} wet", "dirty_one": "{{count}} dirty", "dirty_other": "{{count}} dirty",
    "bed": "Bedtime {{time}}", "bedLater": "Bedtime: tonight", "noBed": "No bedtime logged",
    "usual": "Usual: {{value}}"
  },
  "weekly": {
    "last7": "Last 7 days", "metricLabel": "What to show",
    "metric": { "sleep": "Sleep", "feeds": "Feeds", "diapers": "Diapers" },
    "empty": "Nothing logged these days yet.",
    "lead": { "sleep": "{{name}} slept {{value}} a day on average.", "feeds": "{{value}} feeds a day on average.", "diapers": "{{value}} diapers a day on average." },
    "noBefore": "No earlier days to compare with yet.", "same": "About the same as the 7 days before.",
    "more": "{{value}} more than the 7 days before.", "less": "{{value}} less than the 7 days before.",
    "avg": "avg", "avgLine": "Average", "night": "Night", "naps": "Naps",
    "barSleep": "{{day}}: {{time}} of sleep, night {{night}}, naps {{naps}}. Open this day",
    "bar": {
      "feeds_one": "{{day}}: {{count}} feed. Open this day", "feeds_other": "{{day}}: {{count}} feeds. Open this day",
      "diapers_one": "{{day}}: {{count}} diaper. Open this day", "diapers_other": "{{day}}: {{count}} diapers. Open this day"
    },
    "barNone": "{{day}}: nothing logged. Open this day",
    "usualTitle": "A usual day for {{name}}",
    "usual": { "wake": "Wakes up", "bed": "Bedtime", "naps": "Naps a day", "longest": "Longest sleep at night", "wakings": "Night wakings", "feeds": "Feeds a day", "diapers": "Diapers a day" },
    "note": "Averages of the full days above, from what you logged. Today counts once it's over."
  },
  "week": {
    "range": "{{from}} – {{to}}", "avg": "Avg {{time}} sleep", "prev": "Previous week", "next": "Next week",
    "night": "Night", "naps": "Naps", "feeds": "Feeds", "now": "Now",
    "col": "{{date}}: {{sleep}} sleep, {{feeds}}. Open this day", "loading": "Loading the week…", "empty": "Nothing logged this week."
  },
  "chart": {
    "sleepTitle": "Sleep per day", "timesTitle": "Wake-up and bedtime", "feedsTitle": "Feeds per day",
    "night": "Night", "day": "Day", "wake": "Wake-up", "bed": "Bedtime", "feeds": "Feeds", "date": "Date",
    "tapHint": "Tap a day to see its numbers."
  },
  "quick": {
    "title": {
      "start": "What happened?",
      "sleep": "{{name}} is…",
      "sleeping": "{{name}} is asleep",
      "napLen": "How long did {{name}} sleep?",
      "wake": "When did {{name}} wake up?",
      "feed": "How did {{name}} eat?",
      "feedLen": "How long?",
      "amount": "How much?",
      "solids": "How did it go?",
      "diaper": "What was in it?",
      "med": "Which one?",
      "medName": "Which medicine?",
      "when": "When?",
      "ended": "When did it end?"
    },
    "opt": {
      "sleep": "Sleep",
      "feed": "Feed",
      "diaper": "Diaper",
      "med": "Medicine",
      "asleep": "Asleep now",
      "awake": "Awake again",
      "wokeNow": "Woke up now",
      "wokeEarlier": "Woke up earlier",
      "bottle": "Bottle",
      "solids": "Solids",
      "stopFeed": "Stop feed",
      "vitD": "Vitamin D",
      "other": "Other"
    },
    "more": {
      "label": "Something else",
      "pump": "Pump",
      "growth": "Growth",
      "temperature": "Temperature",
      "tummy": "Tummy time",
      "note": "Note"
    },
    "tag": {
      "next": "Next",
      "last": "Last time",
      "running": "Running"
    },
    "unit": {
      "min": "min",
      "hour_one": "hour",
      "hour_other": "hours",
      "minAgo": "min ago",
      "hourAgo": "hour ago"
    },
    "reaction": {
      "ate": "Ate well",
      "little": "A little",
      "refused": "Refused"
    },
    "startsTimer": "starts a timer",
    "logNap": "log the nap",
    "since": "Since {{time}} · {{dur}}",
    "side": "{{side}} side",
    "stillFeeding": "Still feeding",
    "startTimer": "start a timer",
    "otherAmount": "Other amount",
    "now": "Now",
    "justNow": "just now",
    "minAgo": "{{n}} min ago",
    "hourAgo": "1 hour ago",
    "otherTime": "other time",
    "otherTimeLabel": "Pick a time",
    "medPlaceholder": "e.g. Ibuprofen",
    "next": "Next",
    "save": "Save",
    "back": "Back",
    "close": "Close",
    "progress": "Question {{step}} of {{total}}",
    "saved": "Saved",
    "savedToast": "{{what}} saved",
    "timerStarted": "{{what}} timer started",
    "woke": "Woke up",
    "feedStopped": "Feed stopped",
    "undo": "Undo",
    "err": {
      "generic": "Couldn't save. Please try again.",
      "future": "That time is in the future.",
      "time": "Pick a date and time.",
      "beforeStart": "That's before {{name}} fell asleep.",
      "notRunning": "That timer already stopped.",
      "sleepRunning": "{{name}} is already asleep. Tap Woke up instead.",
      "feedRunning": "A feed is already running. Stop it first."
    }
  }
}
